import { configureStore, combineSlices } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import { languageSelectorDialogSlice } from "@/features/localisation";
import { paymentMethodFormSlice } from "@/features/payment-methods";
import {
  mileageClaimDraftSlice,
  pdfReceiptDraftSlice,
  receiptClaimDraftSlice,
} from "@/features/payments";

import { RESET_STATE } from "./reset-state";

export { RESET_STATE };

const persistConfig = {
  key: "root",
  storage,
  // Claim drafts are intentionally in-memory only: they hold transient,
  // sensitive claim data (receipt images, visit info) that we clear when the
  // participant leaves or restarts the flow, so they must not be persisted.
  // A PDF Receipt's key and ticked pages are the one part of a claim kept
  // (`pdfReceiptDraft`), so a refresh brings them back.
  blacklist: [
    "modal",
    "error",
    "languageSelectorDialog",
    "mileageClaimDraft",
    "receiptClaimDraft",
  ],
};

const rootReducer = combineSlices(
  languageSelectorDialogSlice,
  paymentMethodFormSlice,
  mileageClaimDraftSlice,
  receiptClaimDraftSlice,
  pdfReceiptDraftSlice
);

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export const reset = async () => {
  await persistor.purge();
  store.dispatch({ type: RESET_STATE });
};
